export const VUEX_S3FUM_RESPONSE_HANDLER = 'VUEX_S3FUM_RESPONSE_HANDLER'
